module.exports = __webpack_public_path__ + "static/media/image_2_hover.48a33daa.png";